import PropTypes from "prop-types"

import { cn } from "styles/utils"

// size - lg: collection page; sm: PDP product recommendation
const ProductDescription = ({ productName, size = "lg" }) => {
  return (
    <p
      className={cn(
        "desktop:font-normal desktop:mb-16 mb-6 line-clamp-2 h-[calc(1.4em_*_2)] text-ellipsis font-medium",
        size === "lg"
          ? "desktop:line-clamp-1 desktop:h-[1.4em] body"
          : "body-sm"
      )}
      title={productName}
    >
      {productName}
    </p>
  )
}

ProductDescription.propTypes = {
  productName: PropTypes.string,
  size: PropTypes.string,
}

export default ProductDescription
